import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCustomers = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.588 7.487A3.245 3.245 0 0 1 7.84 4.25c.706 0 1.362.225 1.896.606a.75.75 0 1 1-.872 1.22A1.75 1.75 0 0 0 7.84 5.75c-.973 0-1.753.782-1.753 1.737 0 .873.653 1.603 1.51 1.72a.75.75 0 0 1-.205 1.486 3.24 3.24 0 0 1-2.805-3.206m9.702-2.63a3.25 3.25 0 0 1 1.895-.607 3.245 3.245 0 0 1 3.254 3.237c0 1.64-1.224 2.99-2.806 3.206a.75.75 0 0 1-.204-1.486 1.74 1.74 0 0 0 1.51-1.72c0-.955-.78-1.737-1.754-1.737-.383 0-.736.121-1.024.327a.75.75 0 1 1-.871-1.22M8.76 9.144a3.245 3.245 0 0 1 3.253-3.237 3.245 3.245 0 0 1 3.254 3.237 3.245 3.245 0 0 1-3.254 3.237A3.245 3.245 0 0 1 8.76 9.145m3.253-1.737c-.973 0-1.753.782-1.753 1.737s.78 1.737 1.753 1.737 1.754-.782 1.754-1.737-.78-1.737-1.754-1.737m-4.55 4.725h.065a7.5 7.5 0 0 1 1.542.223.75.75 0 1 1-.373 1.453 6 6 0 0 0-1.202-.175c-2.781.134-3.968 1.898-4.464 3.049l.026.002h1.446a.75.75 0 1 1 0 1.5H3.057c-.977 0-1.888-.947-1.425-2.046.609-1.44 2.188-3.847 5.83-4.006m9.036 0h.065c3.642.159 5.222 2.565 5.83 4.006.464 1.099-.448 2.046-1.424 2.046h-1.447a.75.75 0 0 1 0-1.5h1.447l.025-.002c-.495-1.151-1.682-2.915-4.464-3.05a6 6 0 0 0-1.202.176.75.75 0 0 1-.373-1.453 7.5 7.5 0 0 1 1.543-.223m-9.295 6.208.025.002h9.569q.015 0 .025-.003c-.513-1.191-1.773-3.057-4.81-3.057s-4.296 1.866-4.81 3.057m-1.4-.543c.63-1.495 2.303-4.015 6.21-4.015s5.578 2.52 6.208 4.015c.215.51.123 1.043-.173 1.435-.287.381-.75.61-1.251.61h-9.57c-.501 0-.963-.229-1.251-.61a1.43 1.43 0 0 1-.173-1.435"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCustomers;
